import React from 'react';
import Block from 'Components/Core/Block';
import Menu from 'Components/App/Menu';
import NewThreadShort from 'Components/Forum/NewThreadShort';
import Avatar from 'Components/Member/Avatar';
import cancelBrokerageSession from 'Components/Banking/cancelBrokerageSession';
import axios from "axios";
import './NavigationTop.css';

export default function NavigationTop(props) {

	const [showAvatarFlag, setShowAvatarFlag] = React.useState(false);
	const longPressTimer = React.useRef(null);
	// x.was.avatarimage ist ein einfaches mutable Feld (wird u.a. in MemberListBasis
	// gesetzt, sobald die Mitgliederliste geladen ist). Ohne eigenen State wuerde die
	// Navigationsleiste den Wert nur bei einem zufaelligen Re-Render aus anderem Grund
	// uebernehmen - kommt die Mitgliederliste (z.B. auf dem iPhone öfter) erst nach dem
	// ersten Render an, bleibt so faelschlich der Default-Avatar sichtbar.
	const [avatarImage, setAvatarImage] = React.useState(props.x.was.avatarimage);
	props.x.was.setNavAvatarImage = setAvatarImage;

	// Comdirect-Sitzungsstatus (Chat-Modus, Umbau 2026-07-26, Nutzervorgabe):
	// es ist immer nur eine Verbindung gleichzeitig aktiv, gesetzt von jedem
	// erfolgreichen Brokerage-Login/-Aktions-Abschluss ueber
	// x.was.setBrokerageSession (siehe applyBrokerageSession.js). Beim
	// Seitenaufruf/-neuladen einmalig vom Server abgefragt, da ein Reload
	// diesen React-Zustand sonst zuruecksetzt, obwohl serverseitig eventuell
	// noch eine gueltige Verbindung besteht.
	const [brokerageSession, setBrokerageSession] = React.useState(null);
	props.x.was.setBrokerageSession = setBrokerageSession;
	// x.was.brokerageSession selbst mitschreiben (nicht nur den React-Zustand
	// hier) - andere Komponenten (z.B. syncBrokerageNow.js) lesen es direkt
	// als mutable Feld, wie auch sonst bei x.was ueblich (siehe avatarimage).
	props.x.was.brokerageSession = brokerageSession;

	React.useEffect(() => {
		if (!props.x.was.banking) return;
		props.x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageSessionStatus', {}, (result) => {
			if (result.data.returncode === 1) {
				setBrokerageSession(result.data.content.brokerageSession || null);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Minütliches Neu-Rendern, damit die verbleibende Zeit sichtbar mitzaehlt
	// und die Anzeige nach Ablauf automatisch verschwindet (comdirects eigene
	// ~10 Minuten Token-Gueltigkeit, kein eigener Verfall noetig).
	const [, forceTick] = React.useReducer((c) => c + 1, 0);
	React.useEffect(() => {
		const interval = setInterval(forceTick, 30000);
		return () => clearInterval(interval);
	}, []);

	const brokerageMinutesLeft = brokerageSession && brokerageSession.expiresAt
		? Math.max(0, Math.ceil((brokerageSession.expiresAt - Date.now()) / 60000))
		: null;

	// Nach comdirects eigenem Token-Ablauf (~10 Minuten) die Anzeige selbst
	// zuruecksetzen statt eine "0 min"-Anzeige stehen zu lassen.
	React.useEffect(() => {
		if (brokerageSession && brokerageMinutesLeft <= 0) {
			setBrokerageSession(null);
		}
	}, [brokerageSession, brokerageMinutesLeft]);

	function brokerageLogout(e) {
		e.stopPropagation();
		cancelBrokerageSession(props.x, brokerageSession.connectionId, () => setBrokerageSession(null));
	}

	React.useEffect(() => {
		if (!showAvatarFlag) return;
		const hideOnOutsideClick = () => setShowAvatarFlag(false);
		document.addEventListener('click', hideOnOutsideClick);
		return () => document.removeEventListener('click', hideOnOutsideClick);
	}, [showAvatarFlag]);

	function startLongPress() {
		longPressTimer.current = setTimeout(() => setShowAvatarFlag(true), 500);
	}

	function cancelLongPress() {
		clearTimeout(longPressTimer.current);
	}

    const x = props.x;

	let menuSource = '';                // Enthält die Menü-Daten vom Server. Diese werden dann in der Funktion makeMenu aufbereitet.

	// x.was.openNewThread = openNewThread;

	if (window.webapp.system.webapp === 1) {
		window.webapp.system.webapp = 2;
		getNavigation();
	}

	function getNavigation() {
		let rc = true;
		// let url = document.location.href + '/Backend/webapp.php?module=System&task=Navigation';
		let url = '/Backend/webapp.php?module=System&task=Navigation';
		axios.get(url)
			.then(result => {
				// console.log(result.data);
				if (result.data['returncode'] === 1) {
					menuSource = result.data['content']['navigation'];
					// setMenu(makeMenu(menuSource));
					makeMenus(menuSource, 'main', 'Hauptmenü', '');
					rc = true;
				}
				else {
					// x.was.activateModule('login', false);
					x.wam.activate('login');
					rc = false;
				}
			})
		return rc;
	}

	function makeMenus(menuSource, id, title, parentId) {
		// console.log('makeMenu: ' + id);
		x.was.addNavigation(<Menu menuSource={menuSource} id={'menu-' + id} x={x}   title={title} menuClick={menuClick} parentId={parentId} />);
		menuSource.forEach(
			function (item, index) {
				if (typeof item.children != 'undefined') {
					if (item.children.length > 0) {
						makeMenus(item.children, item.id, item.title, 'menu-' + id);
					}
				}
			}
		)
		// activateModule('forum');
	}


	function menuClick(item) {
		// event.preventDefault();
		//console.log(item);
		x.wan.hideAll();
		switch (item.module) {
			case 'submenu':
				x.was.activateNavigation(item.href);
				break;
			case 'function':
				x.was[item.href]();
				break;
			case 'extern':
				window.open(item.href);
				break;
			case 'logout':
				x.was.logout();
				break;
			default:
				x.wam.activate(item.module);
		}
	}

	function openNewThread() {
		if (x.was.memberLevel >= 4) return;
		const forumId = x.wam.getForumId();
		const wafId = forumId + '-new-thread';
		const newPostingShort = x.waf.get('new-thread-short-default', 'new-posting-short');

		const postingBackup = x.wau.postingRestore(wafId, 0);

		if (postingBackup === null || postingBackup.trim() === '') { 
			x.wau.postingBackup(wafId, 0, newPostingShort);
			x.waf.set(forumId + '-new-thread', 'posting', newPostingShort);
		}
		x.wam[forumId].showDialogNewThread();
		if (typeof x.wam[forumId].setTab === 'function') x.wam[forumId].setTab('postings');
		x.wam.activate(forumId);
	}

	function activateHome() {
		x.wam.activate('forum');
		x.wam['forum'].scrollTop();
	}
	// const props.forumUnread = (typeof x.was.postingsUnread === 'undefined') ? 0 : x.was.postingsUnread.forum;
	const unreadHint = (props.forumUnread > 0) ? " (" + props.forumUnread + ((props.forumUnread > 1) ? " ungelese Beiträge)" : " ungelesener Beitrag)") : '';
	// console.log(props.forumUnread);
	return (
		<Block key="navigation-top" id="navigation-top " x={x} display="d-block" classes={`navigation navigation-top `} >

			<i id="home-icon" className={`bi ${(props.forumUnread > 0) ? 'bi-house-fill' : 'bi-house'} ' navigation-icon`} title={x.was.application + " anzeigen " + unreadHint} onClick={activateHome}>
				<span
					className={` ${props.forumUnread > 0 ? '' : 'd-none'} new-postings-icon-count `}
				>
					{(props.forumUnread > 99) ? "++" : props.forumUnread}
				</span>

			</i>
			{x.was.chatMode &&
				<span
					id="navigation-top-avatar"
					className="mobile-icon navigation-top-avatar"
					onTouchStart={startLongPress}
					onTouchEnd={cancelLongPress}
					onTouchCancel={cancelLongPress}
					onClick={(e) => { e.stopPropagation(); x.wam.activate('settings'); }}
				>
					<Avatar memberLevel={x.was.memberLevel} avatarText={x.was.memberName} image={avatarImage} size="large" />
					{/* Desktop: Anzeige rein per CSS :hover (kein JS-Mouse-Listener - sonst
					    verlangt iOS Safari zwei Taps, da der erste Tap nur den Hover simuliert).
					    Mobil: Anzeige weiterhin ueber Long-Press (showAvatarFlag). */}
					<span className={`navigation-top-avatar-flag ${showAvatarFlag ? 'navigation-top-avatar-flag-visible' : ''}`} onClick={(e) => e.stopPropagation()}>
						Angemeldet als {x.was.memberName}
					</span>
				</span>
			}
			{x.was.chatMode && x.was.banking &&
				<div className="navigation-brokerage-status">
					{/* Nur bei aktiver Comdirect-TAN-Session sichtbar (Minuten-Anzeige +
					    Trennen-Aktion) - ohne Session hat dieses Icon keine eigene
					    Funktion mehr und zeigte bisher auf dasselbe Ziel wie das
					    Euro-Icon direkt daneben ("Zur Depotübersicht", doppelt). */}
					{brokerageSession &&
						<button
							type="button"
							className="navigation-brokerage-minutes"
							title="Comdirect-Verbindung trennen"
							onClick={brokerageLogout}
						>
							{brokerageMinutesLeft > 0 && <span>{brokerageMinutesLeft} min</span>}
							<img src="/comdirect-favicon.ico" alt="comdirect" className="navigation-brokerage-icon" />
						</button>
					}
					{/* Chat vom 2026-08-07 (Nutzerfeedback: "keine klare Unterscheidung
					    erkennbar") - unterschiedliche Titel/Icon-Formen allein reichten
					    nicht. Jetzt zwei sichtbar getrennte Gruppen (eigener Hintergrund
					    + das jeweilige Broker-Favicon voran), je Broker EIN Blick statt
					    Hovern noetig. Chat vom 2026-08-08 (Nutzerfeedback): das eigene
					    "Depotübersicht"-Icon je Broker war neben dem Logo redundant -
					    das Logo selbst ist jetzt klickbar und fuehrt zur Depotuebersicht
					    des jeweiligen Brokers, das Orderbuch-Icon (bi-receipt) ist bei
					    beiden Brokern bewusst dasselbe (Orderbuch ist Orderbuch,
					    unabhaengig vom Broker - die Logo-Zuordnung links davon reicht
					    zur Unterscheidung). */}
					<div className="navigation-broker-group" title="Comdirect">
						<img
							src="/comdirect-favicon.ico"
							alt="Comdirect"
							className="navigation-broker-group-logo navigation-broker-group-logo-clickable"
							title="Comdirect-Depot"
							onClick={() => x.wam.activate('brokerage-overview')}
						/>
						<i className="bi bi-receipt navigation-icon" title="Orderbuch (Comdirect)" onClick={() => x.wam.activate('brokerage-orderbook')}></i>
					</div>
					<div className="navigation-broker-group" title="Interactive Brokers">
						<img
							src="/ib-logo-v5.png"
							alt="Interactive Brokers"
							className="navigation-broker-group-logo navigation-broker-group-logo-clickable"
							title="IB-Depot"
							onClick={() => x.wam.activate('ib-brokerage-overview')}
						/>
						<i className="bi bi-receipt navigation-icon" title="Orderbuch (IB)" onClick={() => x.wam.activate('ib-brokerage-orderbook')}></i>
					</div>
					<i className="bi bi-broadcast navigation-icon" title="Watchlist Live" onClick={() => x.wam.activate('marketdata-quotes')}></i>
					<i className="bi bi-graph-up navigation-icon" title="Charts" onClick={() => x.wam.activate('marketdata-charts')}></i>
				</div>
			}
			{!x.was.chatMode &&
				<i id="new-posting-icon" className={`bi bi-pencil-square navigation-icon ${x.was.memberLevel >= 4 ? 'navigation-icon-disabled' : ''}`} title="Eingabeformular öffnen" onClick={event => openNewThread()}></i>
			}
			{!x.was.chatMode &&
				<NewThreadShort x={x} disabled={x.was.memberLevel >= 4} />
			}
			<i className="bi bi-list navigation-icon" title="Navigation" onClick={e => x.was.activateNavigation('menu-main')}></i>
		</Block>


	);

}
